export const ROUTER_PARAMS_NAMES = {
    workspace: 'workspace',
    account: 'account',
}
